import React, { useEffect, useState } from 'react';
import OptimizedImage from './OptimizedImage';
import '../styles/FooterContacto.css';

const FooterContacto = () => {
  const [contacto, setContacto] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/data/contacto.json')
      .then(res => res.json())
      .then(setContacto);
  }, []);

  if (!contacto) return null;

  return (
    <footer className="footer-contacto">
      <h3>Contáctanos</h3>
      <div className="whatsapp">
        <div className="whatsapp-text">
          Puedes escribirnos a nuestro WhatsApp:
        </div>
        <div className="whatsapp-link-container">
          <a href={contacto.whatsapp} className="whatsapp-button" target="_blank" rel="noopener noreferrer">
            <OptimizedImage 
              src="/assets/wsp.png" 
              alt="WhatsApp icon" 
              className="social-icon"
              width={50}
              height={50}
              sizes="50px"
              fixedContainer={true}
            />
          </a>
        </div>
      </div>
      
      <div className="social-media-intro">Plataformas oficiales de AITher Educación</div>
      <div className="social-links">
        {contacto.redes.map(red => {
          let imgSrc = '';
          switch (red.nombre.toLowerCase()) {
            case 'facebook':
              imgSrc = '/assets/boton fb.png';
              break;
            case 'instagram':
              imgSrc = '/assets/boton ig.png';
              break;
            case 'youtube':
              imgSrc = '/assets/boton yt.png';
              break;
            case 'tiktok':
              imgSrc = '/assets/boton tiktok.png';
              break;
            case 'canal_whatsapp':
              imgSrc = '/assets/wsp.png';
              break;
            default:
              return null;
          }
          return (
            <a key={red.nombre} href={red.url} target="_blank" rel="noopener noreferrer">
              <OptimizedImage 
                src={imgSrc} 
                alt={`${red.nombre} icon`} 
                className="social-icon"
                width={50}
                height={50}
                sizes="50px"
                fixedContainer={true}
              />
            </a>
          );
        })}
      </div>
            
      <div className="footer-copyright">{contacto.copyright}</div>
    </footer>
  );
};

export default FooterContacto; 